import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { WebLocation, WebPriceCalculator, WebCustomer, WebCompany } from "src/app/models";
import { LocationListService } from "src/app/services/location-list.service";
import { Subscription } from "rxjs";
import { WebSettings } from "src/app/models";
import { CompanyService, SharedService } from "src/app/services";
import { ChangeDetectorRef } from "@angular/core";
import { Observable } from "rxjs";
@Component({
  selector: "app-price-calculator",
  templateUrl: "./price-calculator.component.html",
  styleUrls: ["./price-calculator.component.scss"],

})
export class PriceCalculatorComponent implements OnInit
{
  company$: Observable<WebCompany>;

  originalWebPriceCalculator: WebPriceCalculator = {};
  priceCalculatorSubscription: Subscription;
  calculatedTotal: number = 0;
  taxes: number = 0;
  otherCharges: number = 0;
  quantity: number = 0;
  price: number = 0;
  maxQuantity: number;
  minQuantity: number;
  userTankLevel: number;
  showError: boolean = false;
  showWarning: boolean = false;
  messageForCODPaymentRequiredBeforeDelivery: string = "";
  isPriceCalculatorEnabled: boolean;
  areAmountsLockedIn: boolean;
  areThresholdAmountsEnabled: boolean;
  invalidQuantityMessage: string = "";
  mismatchQtyPercentageMesssage: string = "";
  private calcDebounceTimer: any;
  webPriceCalculatorItems: WebPriceCalculator = { ...this.originalWebPriceCalculator };

  priceCalculatorData = {
    LocationPrice: this.price.toFixed(5),
    Quantity: this.quantity,
    OtherCharges: this.otherCharges,
    Taxes: this.taxes,
    CalculatedTotal: this.calculatedTotal
  }
  @Input() selectedLocation: WebLocation;
  @Input() customer: WebCustomer;
  @Input() tankLevel: number;
  @Input() isCustomerRequiredToPayBeforeDelivery: boolean;
  @Output() errorPresent = new EventEmitter<boolean>();
  webSettingsSubscription: Subscription;
  webSettings: WebSettings;

  constructor(
    private locationListService: LocationListService,
    private companyService: CompanyService,
    private cdRef: ChangeDetectorRef
  ) 
  {
    this.company$ = this.companyService.company;
  }

  ngOnInit(): void
  {
    this.webSettingsSubscription = this.companyService.webSettings.subscribe(w =>
    {
      if (w)
      {
        this.webSettings = w;
        this.isPriceCalculatorEnabled = w.IsPriceCalculatorEnabled ?? false;
        this.areAmountsLockedIn = w.IsPriceCalculatorAmountsLockEnabled ?? false;
        this.areThresholdAmountsEnabled = w.AreThresholdAmountsForDeliveryEnabled ?? false;

        this.minQuantity = this.areThresholdAmountsEnabled ? this.webSettings?.MinDeliveryAmount : 0;
        if (this.isCustomerRequiredToPayBeforeDelivery)
        {
          this.messageForCODPaymentRequiredBeforeDelivery =
            !SharedService.IsNullOrEmpty(w.PaymentRequiredForCODDeliveryMessage)
              ? w.PaymentRequiredForCODDeliveryMessage
              : "Payment is required before delivery. Calculate the number of units you want and continue to make a payment.";
        }
      }
    });
    this.checkForEstimatedPercent();
  }

  ngOnChanges(changes: SimpleChanges)
  {
    this.userTankLevel = 0;
    if (changes['tankLevel'] && changes['tankLevel'].currentValue > 0)
    {
      this.userTankLevel = changes['tankLevel'].currentValue;
      this.mismatchQtyPercentageMesssage = "";
      this.showWarning = false;
      this.calculatePriceOnPercentage(changes['tankLevel'].currentValue);
    }
    if (changes['selectedLocation'])
    {
      this.selectedLocation = changes['selectedLocation'].currentValue;
      this.showWarning = false;
      this.mismatchQtyPercentageMesssage = "";
      this.checkForEstimatedPercent();
    }
  }

  ngAfterViewChecked(): void
  {
    this.cdRef.detectChanges();
  }

  areAmountsSentToCompanyButNotRequiredToPay(): boolean
  {
    return this.isPriceCalculatorEnabled && this.areAmountsLockedIn && !this.isCustomerRequiredToPayBeforeDelivery;
  }

  areAmountsSentToCompany(): boolean
  {
    if (this.areAmountsLockedIn || this.isCustomerRequiredToPayBeforeDelivery)
    {
      return true
    }
    else
    {
      return false
    }
  }

  checkUserTankLevelVsQuantity(quantity: number)
  {
    if (!this.selectedLocation?.TotalHeatCapacity ||
      this.userTankLevel == null || this.userTankLevel <= 0 ||
      quantity == null || quantity <= 0)
      {
        this.showWarning = false;
        this.mismatchQtyPercentageMesssage = "";
      return;
    }

    const capacityLeft = this.selectedLocation.TotalHeatCapacity * ((100 - this.userTankLevel) / 100);
    if (quantity > capacityLeft)
    {
      this.showWarning = true;
      this.mismatchQtyPercentageMesssage =
        `Warning: Based on the tank level you entered (${ this.userTankLevel }%), 
       the tank may not be able to hold ${ this.quantity } units.`;
    } 
    else
    {
      this.showWarning = false;
      this.mismatchQtyPercentageMesssage = "";
    }
  }

  checkForEstimatedPercent()
  {
    this.showError = false;
    if (this.selectedLocation.TotalHeatCapacity && this.selectedLocation.MaxPerOfFill)
    {
      this.maxQuantity = this.selectedLocation.TotalHeatCapacity * (this.selectedLocation.MaxPerOfFill / 100);
    }
    else
    {
      this.maxQuantity = this.areThresholdAmountsEnabled ? this.webSettings?.MaxDeliveryAmount : null;
    }
    const percentage = this.selectedLocation.EstimatedPercent;
    if (!this.selectedLocation.TotalHeatCapacity)
    {
      this.calculatedTotal = 0;
      this.calculateQuantity(0)
    }
    else
    {
      this.calculatePriceOnPercentage(percentage);
    }
  }

  calculatePriceOnPercentage(percentage: any)
  {
    this.webPriceCalculatorItems.BranchCustId = this.customer.BranchCustId;
    this.webPriceCalculatorItems.LocationId = this.selectedLocation.Loc;
    this.webPriceCalculatorItems.Category = this.selectedLocation.Category;
    this.webPriceCalculatorItems.QuantityTotal = 0;
    this.webPriceCalculatorItems.EstimatedPercent = percentage;
    this.webPriceCalculatorItems.Field = 0;

    this.priceCalculatorSubscription = this.locationListService.getPriceCalculatorItems(this.webPriceCalculatorItems).subscribe(p =>
    {
      this.quantity = parseFloat(p.QuantityTotal.toFixed(0));
      this.price = parseFloat(p.LocationPrice.toFixed(5));
      this.calculatedTotal = p.TotalAmount;
      this.taxes = p.Taxes;
      this.otherCharges = p.OtherCharges;
      this.checkUserTankLevelVsQuantity(this.quantity)
      if (this.maxQuantity != null && (this.quantity > 0) && this.quantity > this.maxQuantity)
      {
        this.showError = true;
        this.errorPresent.emit(this.showError)
        if (!this.selectedLocation.TotalHeatCapacity)
        {
          this.invalidQuantityMessage = "You cannot request more than " + this.maxQuantity + " units."
        }
        else
        {
          this.invalidQuantityMessage = "This location can only hold " + this.maxQuantity + " units."
        }
      }
      else if (this.quantity < this.minQuantity)
      {
        this.showError = true;
        this.errorPresent.emit(this.showError)
        this.invalidQuantityMessage = "You cannot request less than " + this.minQuantity + " units."
      }
      else
      {
        this.showError = false;
        this.errorPresent.emit(this.showError)
        this.invalidQuantityMessage = ""
      }
    });
  }

  calculatePrice(quantityInput: number)
  {
    if ((this.maxQuantity != null) && (quantityInput > 0) && (quantityInput > this.maxQuantity))
    {
      this.showError = true;
      this.errorPresent.emit(this.showError)
      if (!this.selectedLocation.TotalHeatCapacity)
      {
        this.invalidQuantityMessage = "You cannot request more than " + this.maxQuantity + " units."
      }
      else
      {
        this.invalidQuantityMessage = "This location can only hold " + this.maxQuantity + " units."
      }
    }
    else if ((quantityInput > 0) && (quantityInput < this.minQuantity))
    {
      this.showError = true;
      this.errorPresent.emit(this.showError)
      this.invalidQuantityMessage = "You cannot request less than " + this.minQuantity + " units."
    }
    else
    {
      this.showError = false;
      this.errorPresent.emit(this.showError)
      this.invalidQuantityMessage = ""
    }

    if (quantityInput > 0)
      {
        this.webPriceCalculatorItems.BranchCustId = this.customer.BranchCustId;
        this.webPriceCalculatorItems.LocationId = this.selectedLocation.Loc;
        this.webPriceCalculatorItems.Category = this.selectedLocation.Category;
        this.webPriceCalculatorItems.QuantityTotal = quantityInput;
        this.webPriceCalculatorItems.Field = 0;
        this.webPriceCalculatorItems.EstimatedPercent = 0;
        this.priceCalculatorSubscription = this.locationListService.getPriceCalculatorItems(this.webPriceCalculatorItems).subscribe(p =>
          {
            this.quantity = parseFloat(p.QuantityTotal.toFixed(0));
            this.price = parseFloat(p.LocationPrice.toFixed(5));
            this.calculatedTotal = p.TotalAmount;
            this.taxes = p.Taxes;
            this.otherCharges = p.OtherCharges;
            this.checkUserTankLevelVsQuantity(quantityInput);
      });
    }
  }

  onUserInput(event: Event): void
  {
    const inputElement = event.target as HTMLInputElement;
    const newValue = parseFloat(inputElement.value);
    if (!isNaN(newValue))
    {
      this.priceCalculatorData.CalculatedTotal = newValue;
      this.calculateQuantity(newValue);
    }
  }

 

  onQuantityChange(quantity: number)
  {
    clearTimeout(this.calcDebounceTimer);
    this.calcDebounceTimer = setTimeout(() =>
    {
      this.calculatePrice(quantity);
    }, 400);
  }


  calculateQuantity(totalPriceInput: any)
  {
    this.showError = false;
    this.webPriceCalculatorItems.BranchCustId = this.customer.BranchCustId;
    this.webPriceCalculatorItems.LocationId = this.selectedLocation.Loc;
    this.webPriceCalculatorItems.Category = this.selectedLocation.Category;
    this.webPriceCalculatorItems.TotalAmount = totalPriceInput;
    this.webPriceCalculatorItems.Field = 1;
    this.webPriceCalculatorItems.EstimatedPercent = 0;
    this.priceCalculatorSubscription = this.locationListService.getPriceCalculatorItems(this.webPriceCalculatorItems).subscribe(p => 
    {
      this.quantity = parseFloat(p.QuantityTotal.toFixed(0));
      this.price = parseFloat(p.LocationPrice.toFixed(5));
      this.taxes = p.Taxes;
      this.otherCharges = p.OtherCharges;
      if (this.quantity > 0)
        this.checkUserTankLevelVsQuantity(this.quantity);
      if (this.maxQuantity != null && (this.quantity > 0) && this.quantity > this.maxQuantity)
      {
        this.showError = true;
        this.errorPresent.emit(this.showError)
        if (!this.selectedLocation.TotalHeatCapacity)
        {
          this.invalidQuantityMessage = "You cannot request more than " + this.maxQuantity + " units."
        }
        else
        {
          this.invalidQuantityMessage = "This location can only hold " + this.maxQuantity + " units."
        }
      }
      else if (this.quantity < this.minQuantity)
      {
        this.showError = true;
        this.errorPresent.emit(this.showError)
        this.invalidQuantityMessage = "You cannot request less than " + this.minQuantity + " units."
      }
      else
      {
        this.showError = false;
        this.errorPresent.emit(this.showError)
        this.invalidQuantityMessage = ""
      }
    });
  }

  clearForm()
  {
    this.quantity = 0;
    this.price = 0;
    this.taxes = 0;
    this.otherCharges = 0;
    this.calculatedTotal = 0;

    this.checkForEstimatedPercent();
  }

  getPriceCalculatorTotals()
  {
    const priceCalculatorTotals = {
      QuantityTotal: this.quantity,
      CalculatedTotal: this.calculatedTotal,
      LocationPrice: parseFloat(this.price.toFixed(5))
    }
    return priceCalculatorTotals
  }

  ngOnDestroy()
  {
    this.priceCalculatorSubscription?.unsubscribe();
    this.webSettingsSubscription?.unsubscribe();
  }

}
